import { CardContent, CardHeader, CardTitle, Card } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import { furtherInformationMessages } from './messages';

type FurtherInformationCardProps = {} & React.PropsWithChildren;

export const FurtherInformationCard: React.FC<FurtherInformationCardProps> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <Card className="bg-color-background-base">
      <CardHeader hasDivider className="py-1">
        <CardTitle>{formatMessage(furtherInformationMessages.cardTitle)}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 py-1.5 md:pb-2">{children}</CardContent>
    </Card>
  );
};
